import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { DashboardMentoringPages } from "../../../../Mentoring";
import { useAppUser } from "../../../../../../../contexts/user-context/UserContext";
import { useFunctions } from "reactfire";
import { BarLoader } from "react-spinners";
import UserNotification from "../../../../../../../shared/components/Notification/UserNotification";
import {useAppContext} from "../../../../../../../contexts/app-context/AppContext";

interface IProps {
  id: string;
  photoURL: string;
  title: string;
  bio: string;
  designation: string;
  qualification: string;
  onRequest: (id: string) => void;
}

const MentorRequestCard = (props: IProps) => {
  const { push } = useHistory();
  const appUser = useAppUser();
  const app = useAppContext();
  const [show, setShow] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState<{
    id: string;
    name: string;
  }>({ id: "", name: "" });

  const addMentorSessionRequestFunction = useFunctions().httpsCallable(
    "addMentorSessionRequest"
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (appUser.teams[0]) setSelectedTeam(appUser.teams[0]);
  }, [appUser.teams]);

  const sendRequest = () => {
    setLoading(true);
    addMentorSessionRequestFunction({
      requestedTeamId:
        appUser.teamIds.length === 1 ? appUser.teamIds[0] : selectedTeam.id,
      requestedTeamName:
        appUser.teams.length === 1 ? appUser.teams[0].name : selectedTeam.name,
      requestedTeamMemberId: appUser.memberId,
      requestedMentorId: props.id,
      requestedMentorName: props.title,
      country: appUser.country,
    })
      .then(() => {
        UserNotification({
          isSuccess: true,
          message: "Session succusfully requested",
        });
      })
      .catch(() => {
        UserNotification({
          isSuccess: false,
          message: "Session request failed",
        });
      })
      .finally(() => {
        setLoading(false);
        setShow(false);
      });
  };

  return (
    <Col md={6} lg={4} className="pb-4">
      <div className="mentor-card-wrapper">
        {/*<img src={props.photoURL} alt="" />*/}
        <div
          className="image-wrapper"
          style={{
            backgroundImage: `url(${props.photoURL})`,
            backgroundSize: "100% 100%",
            cursor: "pointer"
          }}
          onClick={() => {
            app.pushBackURL("/dashboard/sessions/mentors");
            push(`${DashboardMentoringPages.MENTOR_PROFILES}/${props.id}`);
          }
          }
        />
        <div className="card-data">
          <label
            className="card-title"
            onClick={() => {
              app.pushBackURL("/dashboard/sessions/mentors");
              push(`${DashboardMentoringPages.MENTOR_PROFILES}/${props.id}`);
            }
            }
          >
            {props.title + (props.qualification ? ", " + props.qualification : "")}
          </label>
          <label className="card-description">{props.designation}</label>
          {!appUser.userRole.isModerator && (
            <div className="card-button-wrapper">
              {loading && !show ? (
                <div style={{ height: "34px" }}>
                  <BarLoader
                    height={4}
                    width={"100%"}
                    color={"#006699"}
                    loading={loading}
                  />
                </div>
              ) : (
                <button
                  onClick={() => {
                    if (appUser.teamIds.length === 1) {
                      sendRequest();
                    } else {
                      setShow(true);
                    }
                  }}
                >
                  Request Session
                </button>
              )}
            </div>
          )}
        </div>
      </div>
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select a team</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Row>
              <Col xs={12} className="text-right mb-3">
                <select
                  className="app-input"
                  value={selectedTeam.id}
                  onChange={(e) => {
                    e.persist();
                    setSelectedTeam((ps) => {
                      const [selectedTeam] = appUser.teams.filter(
                        (t) => t.id === e.target.value
                      );
                      if (selectedTeam) setSelectedTeam(selectedTeam);
                      return ps;
                    });
                  }}
                >
                  {appUser.teams.map((team, index) => {
                    return (
                      <option value={team.id} key={index}>
                        {team.name}
                      </option>
                    );
                  })}
                </select>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="text-right mb-3">
                {loading ? (
                  <div style={{ height: "34px" }}>
                    <BarLoader
                      height={4}
                      width={"100%"}
                      color={"#006699"}
                      loading={loading}
                    />
                  </div>
                ) : (
                  <>
                    <div
                      className="cancel-button blue"
                      style={{ marginRight: "15px" }}
                      onClick={() => setShow(false)}
                    >
                      Cancel
                    </div>
                    <div
                      className="save-button"
                      style={{ marginLeft: "15px" }}
                      onClick={() => {
                        sendRequest();
                      }}
                    >
                      Send Request
                    </div>
                  </>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Col>
  );
};

export default MentorRequestCard;
